import {
  EditOutlined,
  MailOutlined,
  StopOutlined,
  LinkOutlined,
  PlusOutlined,
  NodeIndexOutlined,
} from "@ant-design/icons";
import { PageHeader, Popconfirm, Progress, Tag, Tooltip, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem, SegmentedItem, TableItemDinamico } from "../../../../Components/Items";
import ElegirOrigenOrdenDeMaquila from "./ElegirOrigenOrdenDeMaquila/ElegirOrigenOrdenDeMaquila";
import SeguimientoOrdenDeMaquila from "./SeguimientoOrdenDeMaquila/SeguimientoOrdenDeMaquila";
import MandarCorreoOrdenDeMaquila from "./MandarCorreoOrdenDeMaquila/MandarCorreoOrdenDeMaquila";
import moment from "moment";
import "moment/locale/es";

moment.locale("es");

const ETIQUETA_ESTADO = {
  0: { texto: "Cancelada", color: "red" },
  1: { texto: "Abierta", color: "blue" },
  2: { texto: "En proceso", color: "orange" },
  3: { texto: "Terminada", color: "green" },
};

class OrdenesDeMaquila extends Component {
  tableRef = null;
  state = {
    todasOrdenes: [],
    loading: false,
    // 0 canceladas · 1 abiertas · 2 en proceso · 3 terminadas · 4 todas
    valor: 4,
    totalRecords: 0,
    textoFiltro: "",
    modalOrigenVisible: false,
    modalSeguimientoVisible: false,
    modalCorreoVisible: false,
    modalId: null,
  };

  consultarOrdenes(params) {
    this.setState({ loading: true });
    axios
      .post(
        "ordenesDeMaquila/selectOrdenesDeMaquila",
        { empresaId: this.props.empresaId, ...params },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success !== 2) {
          this.setState({ todasOrdenes: [] });
        } else {
          this.setState({
            todasOrdenes: res.data.data,
            totalRecords: res.data.totalRecords || 0,
          });
        }
      });
  }

  recargar() {
    if (this.tableRef) {
      this.tableRef.updateExternalFilters({ valor: this.state.valor, textoFiltro: this.state.textoFiltro });
    }
  }

  cancelarOrden(ordenDeMaquilaId) {
    this.setState({ loading: true });
    axios
      .post(
        "ordenesDeMaquila/cancelarOrdenDeMaquila",
        { empresaId: this.props.empresaId, ordenDeMaquilaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Orden de maquila cancelada");
        } else {
          message.error(res.data.message || "Sucedió un error y no se pudo cancelar");
        }
        this.recargar();
      });
  }

  agregarOrden() {
    this.setState({ modalOrigenVisible: true });
  }

  verOrden(id) {
    this.props.history.push("/panel/vistaOrdenDeMaquila", { id, modo: "ver" });
  }

  editarOrden(id) {
    this.props.history.push("/panel/vistaOrdenDeMaquila", { id, modo: "editar" });
  }

  verPreCotizacion(preCotizacionId) {
    this.props.history.push("/panel/vistaPreCotizacionIngenieria", { id: preCotizacionId, modo: "ver" });
  }

  render() {
    const columns = [
      {
        title: "Folio",
        dataIndex: "folio",
        key: "folio",
        buscar: "folio",
        width: "9%",
      },
      {
        title: "Nombre de Proyecto",
        dataIndex: "nombreProyecto",
        key: "nombreProyecto",
        buscar: "nombreProyecto",
        width: "16%",
      },
      {
        title: "Cliente",
        dataIndex: "cliente",
        key: "cliente",
        buscar: "cliente",
        width: "13%",
      },
      {
        title: "Encargado",
        dataIndex: "encargadoProyecto",
        key: "encargadoProyecto",
        buscar: "encargadoProyecto",
        width: "11%",
      },
      {
        title: "Cotización",
        dataIndex: "numeroCotizacion",
        key: "numeroCotizacion",
        buscar: "numeroCotizacion",
        width: "9%",
        render: (value) => value || "—",
      },
      {
        title: "Compromiso",
        dataIndex: "fechaCompromiso",
        key: "fechaCompromiso",
        width: "9%",
        render: (value) => (value ? moment(value).format("DD/MM/YYYY") : "—"),
      },
      {
        title: "Avance",
        dataIndex: "materialesTerminados",
        key: "avance",
        width: "10%",
        render: (value, record) => {
          const total = record.totalMateriales || 0;
          if (total === 0) return "—";
          return (
            <Tooltip title={`${value} de ${total} materiales terminados`}>
              <Progress
                percent={Math.round((value / total) * 100)}
                size="small"
                format={() => `${value}/${total}`}
              />
            </Tooltip>
          );
        },
      },
      {
        title: "Estatus",
        dataIndex: "estado",
        key: "estado",
        width: "8%",
        render: (value) => {
          const etiqueta = ETIQUETA_ESTADO[value];
          return etiqueta ? <Tag color={etiqueta.color}>{etiqueta.texto}</Tag> : "—";
        },
      },
      {
        title: "Pre Cotización",
        dataIndex: "preCotizacionId",
        key: "preCotizacionId",
        width: "7%",
        render: (value) =>
          value ? (
            <Tooltip
              title="Ver Pre Cotización"
              placement="top"
              overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}
            >
              <ButtonItem
                type="default"
                size="small"
                lila
                icon={<LinkOutlined />}
                onClick={() => this.verPreCotizacion(value)}
              />
            </Tooltip>
          ) : (
            "—"
          ),
      },
      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        width: "12%",
        render: (value, record) => {
          let buttons = [];

          buttons.push(
            <Tooltip
              key={`tooltip-seguimiento-${record._id}`}
              title="Seguimiento"
              placement="top"
              overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}
            >
              <ButtonItem
                key={`seguimiento-${record._id}`}
                type="default"
                size="small"
                lima
                icon={<NodeIndexOutlined />}
                onClick={() => this.setState({ modalSeguimientoVisible: true, modalId: record._id })}
              />
            </Tooltip>
          );

          buttons.push(
            <Tooltip
              key={`tooltip-correo-${record._id}`}
              title="Mandar Correo"
              placement="top"
              overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}
            >
              <ButtonItem
                key={`correo-${record._id}`}
                type="default"
                size="small"
                blanco
                icon={<MailOutlined />}
                onClick={() => this.setState({ modalCorreoVisible: true, modalId: record._id })}
              />
            </Tooltip>
          );

          if (record.estado !== 0 && record.estado !== 3) {
            buttons.push(
              <Tooltip
                key={`tooltip-editar-${record._id}`}
                title="Editar Orden de Maquila"
                placement="top"
                overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}
              >
                <ButtonItem
                  key={`editar-${record._id}`}
                  type="default"
                  size="small"
                  cyan
                  icon={<EditOutlined />}
                  onClick={() => this.editarOrden(record._id)}
                />
              </Tooltip>
            );
          }

          if (record.estado !== 0) {
            buttons.push(
              <Popconfirm
                key={`cancelar-${record._id}`}
                title="¿Seguro que quieres cancelar esta orden de maquila?"
                onConfirm={() => this.cancelarOrden(record._id)}
                okText="Sí"
                cancelText="No"
              >
                <Tooltip
                  title="Cancelar"
                  placement="top"
                  overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}
                >
                  <ButtonItem type="default" size="small" rojo icon={<StopOutlined />} />
                </Tooltip>
              </Popconfirm>
            );
          }

          return <div className="acciones-container">{buttons}</div>;
        },
      },
    ];

    return (
      <>
        <PageHeader
          title="Órdenes de Maquila"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <>
              {window.innerWidth > 1000 && (
                <SegmentedItem
                  options={[
                    { label: "Abiertas", value: 1 },
                    { label: "En proceso", value: 2 },
                    { label: "Terminadas", value: 3 },
                    { label: "Canceladas", value: 0 },
                    { label: "Todas", value: 4 },
                  ]}
                  onChange={(value) => {
                    if (this.tableRef) {
                      this.tableRef.updateExternalFilters({ valor: value, textoFiltro: this.state.textoFiltro });
                    }
                    this.setState({ valor: value });
                  }}
                  value={this.state.valor}
                />
              )}
              <ButtonItem
                type="primary"
                olivo
                className="botonAgregar"
                key="agregarOrdenDeMaquila"
                onClick={this.agregarOrden.bind(this)}
                icon={<PlusOutlined />}
              >
                Agregar
              </ButtonItem>
            </>
          }
        />
        <TableItemDinamico
          ref={(ref) => (this.tableRef = ref)}
          onRef={(ref) => (this.tableRef = ref)}
          totalRecords={this.state.totalRecords}
          loading={this.state.loading}
          onFetchData={this.consultarOrdenes.bind(this)}
          anadirValorFiltro={this.state.valor}
          size="small"
          dataSource={this.state.todasOrdenes}
          columns={columns}
          scroll={{ x: "max-content" }}
          filterStorageKey={"ordenesDeMaquila" + this.props.empresaId}
          onRow={(record) => ({
            onDoubleClick: () => {
              this.verOrden(record._id);
            },
          })}
          setValor={(valor) => this.setState({ valor })}
          setTextoFiltro={(textoFiltro) => this.setState({ textoFiltro })}
          valorDefault={4}
        />
        <ElegirOrigenOrdenDeMaquila
          visible={this.state.modalOrigenVisible}
          history={this.props.history}
          onCerrar={() => this.setState({ modalOrigenVisible: false })}
        />
        <SeguimientoOrdenDeMaquila
          visible={this.state.modalSeguimientoVisible}
          id={this.state.modalId}
          onCerrar={(huboCambios) => {
            this.setState({ modalSeguimientoVisible: false, modalId: null });
            if (huboCambios) this.recargar();
          }}
        />
        <MandarCorreoOrdenDeMaquila
          visible={this.state.modalCorreoVisible}
          id={this.state.modalId}
          onCerrar={() => this.setState({ modalCorreoVisible: false, modalId: null })}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(OrdenesDeMaquila);
